import UploadingFile from '../entity/UploadingFile';
import generateTempId from './generateTempId';

export default (files: UploadingFile[]) => {
  let uploadingFiles;

  try {
    uploadingFiles = files.map((file) => {
      // Can not upload files larger than 5GB. (5GB -> 5368709120 Byte)
      if (file.size > 5368709120) {
        throw new Error('message.uploading_files_is_larger_than_5gb');
      }

      // Generate a random character string in `file.id` for `Progress Bar`.
      const uploadingId = generateTempId();
      file.id = uploadingId;

      return file;
    });
  } catch (err) {
    throw err;
  }

  return uploadingFiles;
};
